import { Application } from '../../../entities/v1/applicant_tracking/Application';
import { ApiService } from '../../ApiService';

export class ApplicationService {
  public static show(
    id: number,
    expand: string[] = null,
  ): Promise<Application> {
    return ApiService.get<Application>(`/api/v1/applications/${id}`, {
      expand,
    });
  }
}
